export const getDetachTooltipTitle = (forbidden): string | undefined => {
  if (forbidden) {
    return 'Нет доступных дат для открепления';
  }
  return undefined;
};
